<script>
	import { formatPercent } from '../utils/format.js';
  import { intcomma } from 'journalize';
  import parties from '../utils/parties';
  import lastNameDict from '../utils/nameDictionary';

  /** @type {import('../types.d').ReadableRace} */
  export let race;

  // $: console.log($race);


  const offices = {
    'CA-H6227-2024-03-05': ['U.S. House, District 47', `https://www.latimes.com/projects/2024-california-primary-election-live-results/#congressional-section`],
    'CA-I82014-2024-03-05': ['Proposition 1', `https://www.latimes.com/projects/2024-california-primary-election-live-results/#statewide-section`],
    'CA-S8589-2024-03-05': ['U.S. Senate Class I', `https://www.latimes.com/projects/2024-california-primary-election-live-results/#congressional-section`],
    'CA-D82127-2024-03-05': ['District Attorney', `https://www.latimes.com/projects/2024-california-primary-election-los-angeles-live-results/#county-section`],
  };

  $: raceName = offices[$race.id][0];
  $: raceLink = offices[$race.id][1];
	$: totalVotes = $race.total_votes
	$: numOfwinners = $race.number_of_winners
	$: office = $race.office

</script>

<div class="contest">
  <table class="contest__candidates">
    
    <caption class="contest__caption watching-link text-left">
      <a href={raceLink}>
        {raceName}
        <svg class="icon">
          <use xlink:href="#icon-angle-double-right" />
        </svg>
      </a>
    </caption> 
    <thead>
      <tr>
        <th  scope="col" colspan="1" class="contest__candidate-header">
        </th>
        <th scope="col" colspan={1}  class="contest__candidate-header">
          {#if office == "I" }SUPPORT{:else}CANDIDATE{/if}
        </th>
        <th scope="col" class="contest__candidate-header text-left">
          % VOTES
        </th>
        <th scope="col" class="contest__candidate-header text-right">
          TOTAL
        </th>
      </tr>
    </thead>
    <tbody>
      {#each $race.candidates as c, idx}
        {#if idx < 2}
          <tr class="candidate contest__candidate-row">
            <td class="candidate__cell candidate__cell-bar">
              <div
              class="bar bar-{c.party}"
            >
              {#if c.is_winner == true}
                <div class="candidate__cell-winner"> ✓ </div>
              {/if}
            </div>
            </td>
            <th
              scope="row"
              class="candidate__cell candidate__cell-name"
            >
            {c.given_name} {lastNameDict(c.family_name)} 
            {#if c.is_incumbent}
            <span
                  class="candidate__cell-incumbent"
                  title="Currently holds this office">*</span
                >
						{/if}
            {#if !["M","0","I"].includes(office) }
            <span class="candidate__cell-name-party">({parties[c.party].abbr})</span>
            {/if}
            </th>
            <td
              class="candidate__cell candidate__cell-pct text-medium text-left">
  						{formatPercent(c.votes, totalVotes, 1)}
  								<span class="candidate__pct-symbol">%</span>
						</td>
            <td
              class="candidate__cell candidate__cell-pct text-medium text-right">
  						{intcomma(c.votes)}
						</td>
          </tr>
        {/if}
      {/each}
    </tbody>
  </table>
</div>
{#if $race.eevp != null}
  <p class="contest__precincts">{$race.eevp}% of expected vote in</p>
{:else}
  <p class="contest__precincts" >{$race.precincts_reporting_percent}% of precincts reporting</p>
{/if}